/* eslint-disable import/no-anonymous-default-export */
import Workflows from "./Workflows";
import Placeholders from "./Placeholders";
export default {
    id: 101,
    title: 'Early Warnings',
    path: 'early-warning',
    icon: "flaticon2-warning",
    workflows: Workflows,
    placeholders: Placeholders,
};